// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8f19caf2","501":"82fc7e04"}[chunkId] + ".chunk.js";
};